import React from 'react';
import { Grid } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';

export default function DocumentSkeleton () {
  return (
    <Grid container style={{
      marginBottom: '25px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginTop: '20px'
    }}>
      <Grid item xs={2} sm={2}>
        <Skeleton variant='text' width={200} />
        <Skeleton variant='text' width={150} />
      </Grid>
      <Grid item xs={6} sm={6} container spacing={6} style={{
        paddingLeft: '58px'
      }}>
        {Array.from(new Array(4)).map(() => (
          <Grid key={crypto.randomUUID()} item style={{ paddingRight: '50px' }}>
            <Skeleton variant='circle' width={25} height={25} />
          </Grid>

        ))}
      </Grid>
      <Grid item xs={4} sm={4} container spacing={1} style={{
        justifyContent: 'flex-end'
      }} >
        <Grid item>
          <Skeleton style={{
            borderRadius: '5px'
          }} variant='rect' width={150} height={40} />
        </Grid>
        <Grid item>
          <Skeleton style={{
            borderRadius: '5px'
          }} variant='rect' width={150} height={40} />
        </Grid>
        <Grid item>
          <Skeleton style={{
            borderRadius: '5px'
          }} variant='rect' width={120} height={40} />
        </Grid>
      </Grid>
      <Skeleton variant='rect' width={'100%'} height={1} style={{ marginTop: '20px' }} />
    </Grid>
  );
}
